// Entrypoint for BS 2.3 pages. Mirrors application.js but omits popper/bootstrap
// so BS4's vanilla JS plugins don't double-bind alongside /bootstrap2.3/app.js's
// jQuery plugins on the same data-toggle selectors.
import Rails from "@rails/ujs";

Rails.start();

import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

const app = Application.start();

const controllers = import.meta.glob("../controllers/**/*_controller.js", { eager: true });
registerControllers(app, controllers);
